module.exports = __webpack_public_path__ + "img/caas2.661b0973.jpg";